import { create } from 'zustand';
import type { Screen, ToastMessage } from '@/lib/types';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

interface AppState {
  screen: Screen;
  isOnline: boolean;
  isLoading: boolean;
  toasts: ToastMessage[];
  scannerOpen: boolean;

  setScreen: (screen: Screen) => void;
  setOnline: (online: boolean) => void;
  setLoading: (loading: boolean) => void;
  showToast: (
    message: string,
    type: ToastMessage['type'],
    duration?: number,
  ) => void;
  removeToast: (id: string) => void;
  setScannerOpen: (open: boolean) => void;
}

// ---------------------------------------------------------------------------
// Store (runtime only — NOT persisted)
// ---------------------------------------------------------------------------

export const useAppStore = create<AppState>()((set) => ({
  screen: 'caisse',
  isOnline: true,
  isLoading: false,
  toasts: [],
  scannerOpen: false,

  setScreen: (screen) => set({ screen }),

  setOnline: (online) => set({ isOnline: online }),

  setLoading: (loading) => set({ isLoading: loading }),

  showToast: (message, type, duration = 3000) => {
    const id = crypto.randomUUID();
    const toast: ToastMessage = { id, message, type, duration };

    set((state) => ({ toasts: [...state.toasts, toast] }));

    // Auto-remove after duration
    setTimeout(() => {
      set((state) => ({
        toasts: state.toasts.filter((t) => t.id !== id),
      }));
    }, duration);
  },

  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),

  setScannerOpen: (open) => set({ scannerOpen: open }),
}));
